import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import CustomizerContext from '../../../../_helper/Customizer';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { ResolutionStatusApi } from '../../../../api';
import { toast } from 'react-toastify';
import CardRibbonWithForm from '../../../Common/Component/CardRibbonWithForm';
import { base_form_fields, color_field } from '../../../../Data/FormField/PublicData';
import useAxiosPrivate from '../../../../Hooks/useAxiosPrivate';
import { ResolutionStatus } from '../../../../Constant';
import useAuth from '../../../../Hooks/useAuth';
import { can_customer_field } from '../../../../Data/FormField/CrmData';

const ResolutionStatusCreate = () => {
  const history = useNavigate();
  const axiosPrivate = useAxiosPrivate()
  const { userOrganisationId } = useAuth();
  const { layoutURL } = useContext(CustomizerContext);
  const lists = `${process.env.PUBLIC_URL}/crm/settings/resolution-status/${layoutURL}`;

  const { formState: { errors }, } = useForm();
  const [formFields, setFormFields] = useState(base_form_fields(`${ResolutionStatus}`));
  const [isNewFieldAdded, setIsNewFieldAdded] = useState(false);

  useEffect(() => {

    const fetchData = async () => {
      try {
        if (!isNewFieldAdded) {

          const updatedFields = [...formFields];
          const indexOfName = updatedFields.findIndex((formField) => formField.id === 'description');
          updatedFields.splice(indexOfName + 1, 0, color_field(), can_customer_field());

          setFormFields(updatedFields);
          setIsNewFieldAdded(true);
        }
      } catch (error) {
        //console.error('Error fetching options:', error);
      }
    };

    fetchData();
  }, [formFields, isNewFieldAdded, color_field, can_customer_field]);

  const addNewRecord = async (newRecord) => {
    if (newRecord === '') {
      errors.showMessages();
    }

    const newRecordTemp = {
      organisation_id: userOrganisationId,
      name: newRecord.name,
      description: newRecord.description,
      is_active: newRecord.is_active,
      color: newRecord.color,
      can_customer_change: newRecord.can_customer_change,
    };

    try {
      await axiosPrivate.post(ResolutionStatusApi, newRecordTemp, {
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((resp) => {
        toast.success(`${resp.data.name} is successfully added.`)
        history(lists);
      });
    } catch (error) {
      if (error.response && error.response.status === 422) {
        toast.error('Validation Errors');
      } else if (error.response && error.response.status === 400) {
        toast.error(error.response.data.detail);
      }
      else {
        toast.error('Form submission error');
      }
      throw error;
    }
  };

  return (
    <Fragment>
      <Breadcrumbs parent="CRM" title="New Resolution Status" mainTitle="New  Resolution Status" />
      <Container fluid={true}>
        <Row>
          <Col sm='10'>
            <CardRibbonWithForm formFields={formFields} onSubmit={addNewRecord} ribbonUrl={lists} />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ResolutionStatusCreate;